import { adminStoreActions } from '@/store/actions'
import { NotificationState } from '@/store/notifications/notification'
import { ActionReducerMapBuilder } from '@reduxjs/toolkit/react'
import { generateId } from '@repo/shared/uuid/uuid'

export function resourceCases(
  builder: ActionReducerMapBuilder<NotificationState>,
) {
  // TODO: restore
  builder
    .addCase(
      adminStoreActions.resource.update.fulfilled,
      (state, { payload: { resource } }) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xUpdated',
          descriptionTransOptions: { value: resource.title },
          icon: 'check',
          id: generateId(),
        })
      },
    )
    .addCase(
      adminStoreActions.resource.create.fulfilled,
      (state, { payload: { resource } }) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xCreated',
          descriptionTransOptions: { value: resource.title },
          icon: 'check',
          id: generateId(),
        })
      },
    )
    .addCase(
      adminStoreActions.resource.delete.fulfilled,
      (
        state,
        {
          meta: {
            arg: { resourceToDelete },
          },
          payload: { notify },
        },
      ) => {
        if (!notify) return
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xDeleted',
          descriptionTransOptions: { value: resourceToDelete.title },
          icon: 'check',
          id: generateId(),
          undo: {
            actionType: 'delete',
            isUndone: false,
            object: resourceToDelete,
            type: 'resource',
          },
        })
      },
    )
}
